import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";

function AsideNewFeed() {
    const { currentUser } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
        creditzIds: state.profile.creditzIds,
      }));
    return (
        <aside className="left-aside hidden-lg">
            <div className="card border-0 rounded-xl shadow-xs mb-3">
                <div className="card-body p-4">
                    <h5 className="fw-bold fs-12 text-lightgrey mb-3">News Feed</h5>
                    <ul className="aside-iconlist">
                        <li>
                            <Link to="/Home">
                                <span className="bg-red-gradient">
                                    <svg className="icon"><use href="#icon_home"></use></svg>
                                </span>
                                Explore
                            </Link>
                        </li>
                        <li>
                            <Link to="/Creditz">
                                <span className="bg-theme-gradient">
                                    <svg className="icon"><use href="#icon_creditz"></use></svg>
                                </span>
                                Creditz
                            </Link>
                        </li>
                        <li>
                            <Link to="/Search">
                                <span className="bg-slyblue-gradiant">
                                    <svg className="icon"><use href="#icon_personsearch"></use></svg>
                                </span>
                                Find
                            </Link>
                        </li>   
                    </ul>
                </div>
            </div>
            <div className="card border-0 rounded-xl shadow-xs mb-3">
                <div className="card-body p-4">
                    <h5 className="fw-bold fs-12 text-lightgrey mb-3 fw-medium">Account</h5>
                    <ul className="aside-iconlist">
                        <li>
                            <Link to="/Settings">
                                <span>
                                    <svg className="icon"><use href="#icon_settings"></use></svg>
                                </span>
                                Settings
                            </Link>
                        </li>
                        <li>
                            <Link to= {`/Messages`}>
                                <span>
                                    <svg className="icon"><use href="#icon_chat"></use></svg>
                                </span>
                                Chat
                            </Link>
                        </li>  
                    </ul>
                </div>
            </div>
        </aside>
    );
}
export default AsideNewFeed;